import moment from 'moment-timezone';

export const m = x => moment(x).tz(process.env.REACT_APP_TZ);

export const isOverlapped = (selectedShifts = [], startTime, endTime) => {
  for (let i = 0; i < selectedShifts.length; i++) {
    const shift = selectedShifts[i];
    const start = m(shift.startTime).format();
    const end = m(shift.endTime).format();
    if (m(startTime).isBetween(start, end, null, '[)') || m(endTime).isBetween(start, end, null, '(]')) {
      return true;
    }
  }
  return false;
};

export const capitalize = string => {
  const str = string.split('');
  return string ? [str[0].toUpperCase(), ...str.slice(1)].join('') : '';
};

export const indexOfId = (array = [], id) => {
  for (let i = 0; i < array.length; i++) {
    if (array[i].id === id) {
      return i;
    }
  }
  return -1;
};

export const isFullyBooked = (cars = []) => cars.length <= 0;

export const locationString = (location) => {
  const regions = 
    { 
      "ott":"Ottawa",
      "nyc":"New York",
      "sf":"San Francisco",
      "tor":"Toronto",
    }

    return regions[location]
}

export const autzuLocations = [
  'New York',
  'Ottawa',
  'San Francisco',
  'Toronto'
];

export const getURLCity = () => {
  const path = window.location.pathname;
  const city = path.split("/")[1];
  const validCities = ['tor', 'sf', 'ott', 'nyc'];
  return validCities.includes(city) ? city : 'tor';
}


export const urlize = (title) => {
  const cleanedStr = title.replace(/\s+/g, ' ').trim();
  const finalStr = cleanedStr.replace(/ /g, '-').toLowerCase();
  
  return finalStr;
}

export const selectedSrc = (image) => {
  if (image){
      if (image.src){
          return image.src
      }
      if (image.name){
          return image.name
      }
      else{
        return image //for url
      }
  }
  return null
}


// WEBPACK FOOTER //
// ./src/utils/index.js